// import $models from '../..'
import actions from './actions'
import schema from './schema'

export default {
  modelGetters: {

    /* deadlines() {

    }, */

    /* members() {
      // Return GenericModel of type member!
    }, */

    // banner_image() {
    //
    // },
    //
    // dynamic_custom_getter() {
    //
    //   /* INFO: This getter is cached!? */
    //   console.log("[GETTER] dynamic_custom_getter");
    //
    //   /*
    //   let goals = $models.goalMeta.subscribeList()
    //   // let goals = $models.goalMeta.getList()
    //   if ( !goals.$ready ) {
    //     return 0;
    //   }
    //   return Object.keys( goals.items ).length;
    //   */
    // }
  },
  staticGetters: {

    /**
     * get_last_sortidx - returns last sortidx
     */
    get_last_sortidx: ($models, $registry, $store) => {

      let goal_list_user = $store.getters.all_goals_user
      let max_sort_idx = 0;
      for ( let idx in goal_list_user ) {
        max_sort_idx = Math.max( goal_list_user[ idx ].sortidx, max_sort_idx );
      }
      return max_sort_idx + 100
    },

    /* Returns object (not array)!
    *
    */
    all_goals_user: ($models, $registry, $store) => {

      let currentUserId = $models.user.defaultUserId;
      if ( !$registry.state.res.user ||
           !$registry.state.res.user[ currentUserId ] ) {
        return {};
      }

      let goal_list_user = $registry.state.res.user[ currentUserId ].goal_settings
      return goal_list_user
    },

    /*
    *
    */
    all_goals_without_deleted: ($models, $registry, $store) => {
      if ( !$registry.state.res.goal ) {
        return [];
      }

      let goal_meta_list = Object.keys($registry.state.res.goal).map(goalId => {

        let goal_meta = ($registry.state.res.goal[ goalId ] || {}).meta;

        /* Check if goal exists and if we have access rights */
        if ( !goal_meta || goal_meta[ '.exists' ] === false || goal_meta[ '.noaccess' ] === true ) {
          console.log("Goal: No access or does not exist", goalId)
          return null;
        }

        return { $id: goalId, ...goal_meta };
      }).filter(goal_meta => goal_meta != null && !goal_meta.deleted)

      // console.log("goal_meta_list", goal_meta_list)
      return goal_meta_list;
    },

    /*
    * used to be: goal_list_meta_ready_without_deleted
    * $models.goalMeta.getters.all_goals
    * TODO: move to $models.goals
    */
    all_goals_loaded: ( $models, $registry, $store ) => {

      // This means goal meta and goal settings are ready!
      return Object.keys($registry.state.ready).map(entry => {
        if ( entry.startsWith( 'goal:' ) ) {

          let goalId = entry.split(':').pop();
          return $models.goalMeta.getNode( goalId )
        }
      }).filter(e => e && !e.deleted )
      // TODO: .sort(util.sorter.by_sortidx);
      // TODO: return genric list ?
    },

    /*
    *
    */
    get_todays_commitments_grouped_by_goal() {

    }
  },
  listGetters: {

  },
  staticActions: actions,
  schema:  schema
};
